import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OutwardStatus } from 'src/app/Enums/outwardEnum';
import { StatusService } from 'src/app/shared/components/status.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';


@Component({
  selector: 'app-outward-progress-bar',
  templateUrl: './outward-progress-bar.component.html',
  styleUrls: ['./outward-progress-bar.component.less']
})
export class OutwardProgressBarComponent implements OnInit {

  public status : any;
  id: any;
  viewData: any = {}; // Initialize viewData to an empty object
  OutwardStatus : OutwardStatus;
  reachedPrintPass: boolean = false;
  reachedReceived: boolean = false;

  private unsubscribe$ =new Subject<void>();
  service_URL: any;
  constructor(
    private service:StatusService,
    private route: ActivatedRoute,
    private _dataContextService: DataContextService) {
      this.service_URL = ConstantsService;
    }

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    this.getDataById(this.id);
  }

  getDataById(id: number) {
    let url =this.service_URL.OutwardDetails.GetDataById + '/' + id;
       
    this._dataContextService.get<any>(url)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res=>{
      this.viewData = res;
      this.status = this.viewData.status;
      
      // Check audit trail for cancelled records to determine actual cancellation stage
      if (res.status === 'Cancelled' && res.gatepassNo) {
        this.checkAuditTrailForStatus(res.requestId);
      }
    });
    }

  checkAuditTrailForStatus(requestId: string) {
    let url = this.service_URL.AuditTrail.GetStatusHistory.replace('{requestId}', requestId);

    this._dataContextService.get<any>(url)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        
        // Check if we have audit trail data
        if (res.statusHistory && res.statusHistory.length > 0) {
          // Find the cancelled entry
          const cancelledEntry = res.statusHistory.find(h => 
            h.newValue === 'Cancelled' || h.newValue === '11' || h.newValue === 11
          );
          
          if (cancelledEntry && cancelledEntry.oldValue) {
            // Use the old value to determine what stage cancellation happened at
            const oldStatus = cancelledEntry.oldValue.toString();
            
            // Check if cancelled from Print Pass (9) or later
            if (oldStatus === '9' || oldStatus === 'Print Pass' || oldStatus === 'PrintPass') {
              this.reachedPrintPass = true;
              this.reachedReceived = false;
            } 
            // Check if cancelled from Received (10)
            else if (oldStatus === '10' || oldStatus === 'Received') {
              this.reachedPrintPass = true;
              this.reachedReceived = true;
            }
            // Check if it ever reached Print Pass or Received before cancellation
            else {
              this.reachedPrintPass = res.reachedPrintPass || false;
              this.reachedReceived = res.reachedReceived || false;
            }
          } else {
            // No cancelled entry found, use the boolean flags from API
            this.reachedPrintPass = res.reachedPrintPass || false;
            this.reachedReceived = res.reachedReceived || false;
          }
        } else {
          // No audit trail data - use fallback logic for old records
          this.applyFallbackLogic();
        }
      }, error => {
        console.error('Error fetching status history, using fallback logic:', error);
        this.applyFallbackLogic();
      });
  }

  private applyFallbackLogic() {
    // Fallback to existing logic for old records without audit trail
    if (this.viewData.previousStatusId == 9 || this.viewData.previousStatusId == '9') {
      this.reachedPrintPass = true;
      this.reachedReceived = false;
    } else if (this.viewData.previousStatusId == 10 || this.viewData.previousStatusId == '10') {
      this.reachedPrintPass = true;
      this.reachedReceived = true;
    } else if (this.viewData.receivedDate && this.viewData.receivedDate !== '0001-01-01T00:00:00') {
      this.reachedPrintPass = true;
      this.reachedReceived = true;
    }
  }
}
